import type { Common, MstCommon, SegmentMst } from '@libs/domain';

class SegmentMstSetting
  implements
    Pick<MstCommon['schema'], 'codeDigits' | 'displayName'>,
    Pick<Common['schema'], 'isUsed'>,
    Pick<SegmentMst['schema'], 'segmentMstKey'>
{
  private constructor(
    readonly segmentMstKey: number,
    readonly isUsed: boolean,
    readonly displayName: string,
    readonly codeDigits: string,
  ) {}

  static fromRaw(raw: SegmentMstSettingRaw) {
    return new SegmentMstSetting(raw.segmentMstKey, raw.isUsed, raw.displayName, raw.codeDigits);
  }
}

class SegmentMstSettingRaw
  implements
    Pick<MstCommon['record'], 'codeDigits' | 'displayName'>,
    Pick<Common['record'], 'isUsed'>,
    Pick<SegmentMst['record'], 'segmentMstKey'>
{
  private constructor(
    readonly segmentMstKey: number,
    readonly isUsed: boolean,
    readonly displayName: string,
    readonly codeDigits: string,
  ) {}

  static fromModel(model: SegmentMstSetting, defaultName: string) {
    return new SegmentMstSettingRaw(
      model.segmentMstKey,
      model.isUsed,
      model.isUsed ? model.displayName : model.displayName ? model.displayName : defaultName,
      model.isUsed ? model.codeDigits : model.codeDigits ? model.codeDigits : '3',
    );
  }
}

export { SegmentMstSetting, SegmentMstSettingRaw };
